import { useSelector, shallowEqual } from 'react-redux';

import {
  selectAccountId,
  selectElectricityRegisters,
  selectGasRegisters,
  selectElectricityMeterPointId,
  selectGasMeterPointId,
  selectFuelType as selectMoveInFuelType
} from 'state/move-in-date/move-in-date-slice';
import { FUEL_TYPES } from 'config/app-config';

import { selectFuelType } from 'state/fuel-type/fuel-type-slice';

const MOVE_IN_DUAL_FUEL_DATA_MAPPING = {
  DualFuel: {
    [FUEL_TYPES.ELECTRIC]: true,
    [FUEL_TYPES.GAS]: true,
    isAccountId: true,
    isGasMeterPointId: true,
    isElectricityMeterPointId: true,
    isGasRegisters: true,
    isElectricRegisters: true
  },
  Gas: {
    [FUEL_TYPES.ELECTRIC]: false,
    [FUEL_TYPES.GAS]: true,
    isAccountId: true,
    isGasMeterPointId: true,
    isElectricityMeterPointId: false,
    isGasRegisters: true,
    isElectricRegisters: false
  },
  Electricity: {
    [FUEL_TYPES.ELECTRIC]: true,
    [FUEL_TYPES.GAS]: false,
    isAccountId: true,
    isGasMeterPointId: false,
    isElectricityMeterPointId: true,
    isGasRegisters: false,
    isElectricRegisters: true
  }
} as const;

export const useMoveInDataConsistency = () => {
  const accountId = useSelector(selectAccountId, shallowEqual);
  const electricityRegisters = useSelector(
    selectElectricityRegisters,
    shallowEqual
  );
  const gasRegisters = useSelector(selectGasRegisters, shallowEqual);
  const electricityMeterPointId = useSelector(
    selectElectricityMeterPointId,
    shallowEqual
  );
  const gasMeterPointId = useSelector(selectGasMeterPointId, shallowEqual);
  const moveInFuelType = useSelector(selectMoveInFuelType, shallowEqual);
  const fuelType = useSelector(selectFuelType, shallowEqual);

  const toMatch = {
    [FUEL_TYPES.ELECTRIC]: fuelType.electric,
    [FUEL_TYPES.GAS]: fuelType.gas,
    isAccountId: !!accountId,
    isGasMeterPointId: !!gasMeterPointId,
    isElectricityMeterPointId: !!electricityMeterPointId,
    isGasRegisters: gasRegisters && !!gasRegisters.length,
    isElectricRegisters: electricityRegisters && !!electricityRegisters.length
  };

  const fromMatch = moveInFuelType
    ? MOVE_IN_DUAL_FUEL_DATA_MAPPING[
        moveInFuelType as keyof typeof MOVE_IN_DUAL_FUEL_DATA_MAPPING
      ]
    : {};

  return Object.entries(fromMatch).every(([key, value]) => {
    return !!toMatch[key] === !!value;
  });
};
